if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }

      //       const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cartData: response,
      //         }).then(() => {
      //           CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               CartPerformance.measure("add:paint-updated-sections", () => {
      //                 this.cart.renderContents(response);
      //               });
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         CartPerformance.measure("add:paint-updated-sections", () => {
      //           this.cart.renderContents(response);
      //         });
      //         this.submitButton.classList.add('added');

      //         // setTimeout(() => {
      //         //   this.submitButton.classList.remove('added');
      //         // }, 5000);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       this.querySelector('.loading__spinner').classList.add('hidden');

      //       CartPerformance.measureFromEvent("add:user-action", evt);
      //     });
      // }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const mainVariantId = this.form.querySelector('[name="id"]')?.value;
        const mainQty = parseInt(this.form.querySelector('[name="quantity"]')?.value || '1', 10);
        const mainSellingPlanId = this.getSellingPlanId(this.form);

        let items = [];

        // Main product
        if (mainVariantId) {
          items.push(this.buildCartItem(mainVariantId, mainQty, mainSellingPlanId));
        }

        // Checked complete setup products on the same product page only
        const productRoot = this.closest('product-info, [data-product-info]');
        const checkedSetupItems = productRoot
          ? productRoot.querySelectorAll(
              '.complete-setup-wrapper .complete-switch input[type="checkbox"]:checked'
            )
          : [];

        checkedSetupItems.forEach((checkbox) => {
          const variantId = checkbox.dataset.variantId;
          if (variantId) {
            const sellingPlanId = checkbox.dataset.sellingPlanId
              ? parseInt(checkbox.dataset.sellingPlanId, 10)
              : null;
            items.push(this.buildCartItem(variantId, 1, sellingPlanId));
          }
        });

        const bundleContext = window.ScaleBundle
          ? {
              productHandle: window.ScaleBundle.getProductHandleFromElement(this),
              variantId: mainVariantId,
            }
          : null;

        const submitItems = async () => {
          if (window.ScaleBundle && bundleContext) {
            const prepared = await window.ScaleBundle.prepareCartAddItems(items, bundleContext);
            items = prepared.items;
          } else if (window.ScaleBundle) {
            items = window.ScaleBundle.appendPremiumIfNeeded(items, bundleContext);
          }

          if (items.length === 0 && window.ScaleBundle) {
            await window.ScaleBundle.enforceCartBundle(
              null,
              document.querySelector('cart-drawer-items') || document.querySelector('cart-items')
            );
            const response = await this.getEnforcedCartResponse();
            return { enforcedOnly: true, response };
          }

          const payload = { items };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = JSON.stringify(payload);

          const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());

          if (
            response.status &&
            window.ScaleBundle?.isScaleMaxQuantityError(response) &&
            window.ScaleBundle.shouldBundleWithPremium(bundleContext)
          ) {
            await window.ScaleBundle.enforceCartBundle(
              null,
              document.querySelector('cart-drawer-items') || document.querySelector('cart-items')
            );
            const enforcedResponse = await this.getEnforcedCartResponse();
            return { enforcedOnly: true, response: enforcedResponse };
          }

          return { enforcedOnly: false, response };
        };

        submitItems()
          .then(({ enforcedOnly, response }) => {
            if (response?.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');

            if (!this.error && !enforcedOnly) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (response) {
              const canRenderContents =
                response.sections && (this.cart.tagName !== 'CART-NOTIFICATION' || response.key);
              if (canRenderContents) {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              }
              this.submitButton.classList.add('added');
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Something went wrong. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      async getEnforcedCartResponse() {
        if (!this.cart || !window.ScaleBundle) return null;
        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
        return window.ScaleBundle.fetchRenderableCart(sectionIds);
      }

      // handleErrorMessage(errorMessage = false) {
      //   if (this.hideErrors) return;

      //   this.errorMessageWrapper =
      //     this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      //   if (!this.errorMessageWrapper) return;
      //   this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      //   this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      //   if (errorMessage) {
      //     this.errorMessage.textContent = errorMessage;
      //   }
      // }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        const qtyButton =
          this.querySelector('.product-qty-button') || document.querySelector('.product-qty-button');
        if (!qtyButton) return;

        let customError = this.querySelector('.custom-product-error-message');

        if (!customError) {
          customError = document.createElement('div');
          customError.className = 'custom-product-error-message product-form__error-message-wrapper';
          customError.hidden = true;

          // Copy original Shopify error wrapper inner HTML so icon/warning sign also comes
          customError.innerHTML = this.errorMessageWrapper.innerHTML;

          qtyButton.insertAdjacentElement('afterend', customError);
        }

        const customErrorText = customError.querySelector('.product-form__error-message');

        // Hide original but keep original logic working
        this.errorMessageWrapper.style.display = 'none';

        if (errorMessage) {
          if (customErrorText) {
            customErrorText.textContent = errorMessage;
          }
          customError.hidden = false;
        } else {
          if (customErrorText) {
            customErrorText.textContent = '';
          }
          customError.hidden = true;
        }
      }
                


      toggleSubmitButton(disable = true, text, bisMode = false) {
        if (!this.submitButton || !this.submitButtonText) return;

        if (bisMode) {
          this.submitButton.type = 'button';
          this.submitButton.removeAttribute('name');
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.add('klaviyo-bis-trigger');
          this.submitButton.dataset.bisTrigger = 'true';
          if (text) this.submitButtonText.textContent = text;
          return;
        }

        this.submitButton.classList.remove('klaviyo-bis-trigger');
        delete this.submitButton.dataset.bisTrigger;
        this.submitButton.type = 'submit';
        this.submitButton.setAttribute('name', 'add');

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      getSellingPlanId(form) {
        const sellingPlanInput = form?.querySelector(
          '[name="selling_plan"], [name="items[0][selling_plan]"]'
        );
        const sellingPlanId = sellingPlanInput?.value;

        return sellingPlanId ? parseInt(sellingPlanId, 10) : null;
      }

      buildCartItem(variantId, quantity, sellingPlanId = null) {
        const item = {
          id: parseInt(variantId, 10),
          quantity,
        };

        if (sellingPlanId) {
          item.selling_plan = sellingPlanId;
        }

        return item;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
